export default class {
	constructor(type, message, timeout = 5000) {
		this.type = type;
		this.message = message;
		this.timeout = timeout;

		this.create();
		setTimeout(() => this.show(), 10);
	}

	create() {
		this.toast = document.createElement("div");
		this.toast.classList.add("toast", `toast-${this.type}`);

		const p = document.createElement("p");

		p.classList.add("is-style-p2");
		p.innerText = this.message;

		this.toast.appendChild(p);
		document.body.appendChild(this.toast);
	}

	show() {
		this.toast.classList.add("is-visible");

		if (this.timeout) {
			setTimeout(this.hide.bind(this), this.timeout);
		}
	}

	hide() {
		this.toast.classList.add("is-hiding");
		this.toast.classList.remove("is-visible");

		this.toast.addEventListener(
			"transitionend",
			() => this.toast.classList.remove("is-hiding"),
			{ once: true }
		);
	}
}
